import ProgramStore from './store'
import { program as config } from '../config'

export const store = new ProgramStore(config)



// WEBPACK FOOTER //
// ./src/program/index.js